module.exports = __webpack_public_path__ + "img/4-4-marquee-3.e638cdfd.jpg";